import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'principal', pathMatch: 'full' },
  { path: 'principal',
    loadChildren: () => import('./pages/principal/principal.module').then( m => m.PrincipalPageModule)
  },
  { path: 'aparcar',
    loadChildren: () => import('./pages/aparcar/aparcar.module').then( m => m.AparcarPageModule)
  },
  { path: 'acceso',
    loadChildren: () => import('./pages/acceso/acceso.module').then( m => m.AccesoPageModule)
  },
  { path: 'ayuda',
    loadChildren: () => import('./pages/ayuda/ayuda.module').then( m => m.AyudaPageModule)
  },
  { path: 'acceder',
    loadChildren: () => import('./pages/acceder/acceder.module').then( m => m.AccederPageModule)
  },
  { path: 'registrarse',
    loadChildren: () => import('./pages/registrarse/registrarse.module').then( m => m.RegistrarsePageModule)
  },
  { path: 'retirar',
    loadChildren: () => import('./pages/retirar/retirar.module').then( m => m.RetirarPageModule)
  },
  { path: 'mi-cuenta',
    loadChildren: () => import('./pages/mi-cuenta/mi-cuenta.module').then( m => m.MiCuentaPageModule)
  },
  { path: 'add-data',
    loadChildren: () => import('./pages/add-data/add-data.module').then( m => m.AddDataPageModule)
  },
  { path: 'metodos-pago',
    loadChildren: () => import('./pages/metodos-pago/metodos-pago.module').then( m => m.MetodosPagoPageModule)
  },
  { path: 'change-pass',
    loadChildren: () => import('./pages/modals/change-pass/change-pass.module').then( m => m.ChangePassPageModule)
  },
  { path: 'mis-reservas',
    loadChildren: () => import('./pages/mis-reservas/mis-reservas.module').then( m => m.MisReservasPageModule)
  },
  { path: 'elegir-tarjeta-lazo',
    loadChildren: () => import('./pages/elegir-tarjeta-lazo/elegir-tarjeta-lazo.module').then( m => m.ElegirTarjetaLazoPageModule)
  },
  { path: 'elegir-codigo',
    loadChildren: () => import('./pages/elegir-codigo/elegir-codigo.module').then( m => m.ElegirCodigoPageModule)
  },
  { path: 'aviso-legal',
    loadChildren: () => import('./pages/aviso-legal/aviso-legal.module').then( m => m.AvisoLegalPageModule)
  },
  { path: 'contacto',
    loadChildren: () => import('./pages/contacto/contacto.module').then( m => m.ContactoPageModule)
  },
  { path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  { path: 'reserva-dias',
    loadChildren: () => import('./pages/reserva-dias/reserva-dias.module').then( m => m.ReservaDiasPageModule)
  },
  { path: 'reserva-horas',
    loadChildren: () => import('./pages/reserva-horas/reserva-horas.module').then( m => m.ReservaHorasPageModule)
  },
  { path: 'confirmar-reserva',
    loadChildren: () => import('./pages/confirmar-reserva/confirmar-reserva.module').then( m => m.ConfirmarReservaPageModule)
  },
  { path: 'modal-reserva',
    loadChildren: () => import('./pages/modals/modal-reserva/modal-reserva.module').then( m => m.ModalReservaPageModule)
  },
  { path: 'modal-mis-reservas',
    loadChildren: () => import('./pages/modals/modal-mis-reservas/modal-mis-reservas.module').then( m => m.ModalMisReservasPageModule)
  },
  { path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then( m => m.PaymentPageModule)
  },
  { path: 'seleccionar-dia', loadChildren: './pages/seleccionar-dia/seleccionar-dia.module#SeleccionarDiaPageModule' },
  { path: 'confirmar-bono', loadChildren: './pages/confirmar-bono/confirmar-bono.module#ConfirmarBonoPageModule' },
  { 
    path: 'formulario-ses', 
    loadChildren: () => import('./pages/formulario-ses/formulario-ses.module').then(m => m.FormularioSesPageModule) 
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
